const UPDATE_USER = 'UPDATE_USER';
const SIGN_OUT = 'SIGN_OUT';

export default {
  updateUser: (user, profile) => (dispatch) => {
    const actionData = {
      type: UPDATE_USER,
      payload: {
        token: user && user.signInUserSession.idToken.jwtToken,
        profile,
        cognitoUser: user,
      },
    };
    dispatch(actionData);
  },

  signOut: () => ({
    type: SIGN_OUT,
    payload: {
      cognitoUser: null,
      profile: null,
      token: null,
    },
  }),
};
